import { render } from "./RNevent.vue?vue&type=template&id=68d90022"
import script from "./RNevent.vue?vue&type=script&lang=js"
export * from "./RNevent.vue?vue&type=script&lang=js"

import "./RNevent.vue?vue&type=style&index=0&id=68d90022&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__